import { render } from "./SubscriptionEditUpdated.vue?vue&type=template&id=2a8e4d10"
import script from "./SubscriptionEditUpdated.vue?vue&type=script&lang=js"
export * from "./SubscriptionEditUpdated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__